const stickyProductForm = document.querySelector('product-sticky-form');
const productFormHeight = document.querySelector('product-form') || document.querySelector('product-form-fcfs');
function getScrollTopToElement() {
  let element = productFormHeight;
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}
let scrollTopToElement = getScrollTopToElement();
function handleScroll() {
  if (window.scrollY > scrollTopToElement) {
    stickyProductForm?.classList.add('show-sticky-button');
  } else {
    stickyProductForm?.classList.remove('show-sticky-button');
  }
}
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}
window.addEventListener('scroll', debounce(handleScroll, 50));
window.addEventListener('resize', () => {
  scrollTopToElement = getScrollTopToElement();
});



const stickyVariantEle = document.querySelector('.selected__variant-container')
const dropdownEle = document.querySelector('.sticky-variant__selector')
stickyVariantEle?.addEventListener('click',()=> {
  dropdownEle?.classList.toggle('show-sticky-variants')
  document.querySelector('body').classList.add('overflow-hidden')
})

// Hide Dropdown on body click
window.onclick = function(event) {
  if (!event.target.closest('.selected__variant-container')){
    dropdownEle?.classList.remove('show-sticky-variants');
    document.querySelector('body').classList.remove('overflow-hidden')
  }
}